import { css } from '@emotion/core'
import { CommonLimitStyle, TxtLimit } from '@styles/base.style'
import styled, { ThemeProps } from '@themes/theme'

const CommonTitStyle = (props: ThemeProps) => css`
  position: relative;
  color: ${props.theme.color.modalSubBg};
  padding-left: 18px;
  svg {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translate(0,-50%);
    width: 13px;
    height: auto;
    path {
      fill: ${props.theme.color.modalSubBg};
    }
  }
`
export const NoticeCommonTag = styled.span`
  display: inline-block;
  width: 50px;
  height: 20px;
  margin-right: 6px;
  text-align: center;
  font-size: ${props => props.theme.font.small};
  border-radius: 50px;
  border: 1px solid;
  &.event-tag {
    color: ${props => props.theme.color.modalOrange};
    border-color: ${props => props.theme.color.modalOrange};
  }
  &.notice-tag {
     color: ${props => props.theme.color.secondaryBg};
     border-color: ${props => props.theme.color.secondaryBg};
  }
`
export const ClubDetailInfoPopup = styled.div`
  position: relative;
  height: 100%;
  text-align: left;
  padding-bottom: 15%;
  overflow: auto;
  .club-detail-info-bg-wrap {
    position: absolute;
    width: 100%;
    height: 296px;
    overflow: hidden;
    .club-detail-info-bg {
      position: absolute;
      top: 0;
      left: 50%;
      transform: translate(-50%, 0);
      width: auto;
      height: 206px;
    }
  }
  .club-notice {
    position: relative;
    margin: 0 14px;
    backdrop-filter: blur( 5px );
    &--info {
     position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 42px;
      line-height: 4.2rem;
      background: rgba(238, 238, 238, .15);
      box-shadow: 10px 10px 25px 0 rgba( 0, 0, 0, 0.05 );
      border-radius: 10px;
      border: 1px solid rgba(238, 238, 238, .25);
      .info-group {
        flex: 1;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 18px;
      }
      &--member {
        position: relative;
        &::after {
          content: '';
          display: block;
          position: absolute;
          top: 50%;
          right: 0;
          width: 1px;
          height: 16px;
          transform: translateY(-50%);
          border-right: 1px solid rgba(238, 238, 238, .25);
        }
        &--tit {
          ${CommonTitStyle};
          font-weight: ${props => props.theme.fontW.medium};
          transform: translateY(1px);
           & > svg {
              top: 47%;
              width: 12px;
           }
        }
        &--num {
          color: ${props => props.theme.color.themeTxt};
          transform: translateY(1px);
          & > span {
            color: ${props => props.theme.color.modalSubBg};
            font-weight: ${props => props.theme.fontW.medium};
          }
        }
      } /* club-notice--info--member */
      &--message {
        &--tit {
          ${CommonTitStyle};
          font-weight: ${props => props.theme.fontW.medium};
          transform: translateY(1px);
           & > svg {
              width: 14px;
           }
        }
        &--btn {
          z-index: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: ${props => props.theme.font.small};
          width: 64px;
          height: 24px;
          background: ${props => props.theme.color.modalBg};
          span {
            color: ${props => props.theme.color.mainBg};
            font-size: ${props => props.theme.font.small};
            margin-right: 2px;
            transform: translateY(5%);
          }
          svg {
            transform: rotate(-90deg);
            width: auto;
            height: 4px;
            path {
              fill: ${props => props.theme.color.modalSubTxt};
            }
          }
          &.go-club {
            display: block;
          }
          &.current {
            display: none;
          }
        } /* club-notice--info--message--btn */
      } /* club-notice--info--message */
    } /* club-notice--info */
    .tilt {
      border-radius: 10px;
      overflow: hidden;
    }
    &--board {
      margin-top: 15px;
      &--item {
        margin-bottom: 6px;
        background: ${props => props.theme.color.themeTxt};
        border-radius: 10px;
        &--btn {
          display: flex;
          flex-flow: column;
          justify-content: space-between;
          align-items: center;
          border-radius: 0;
          text-align: left;
          width: 100%;
          height: 84px;
          padding: 18px 14px;
          background: none;
          &.no-data {
            justify-content: center;
            color: ${props => props.theme.color.disableTxt};
          }
          &--tit {
            width: 100%;
            font-size: ${props => props.theme.font.large};
            color: ${props => props.theme.color.mainBg};
            ${TxtLimit};
            line-height: 2rem;
          }
          &--contents {
            width: 100%;
            margin-left: 4px;
            color: ${props => props.theme.color.modalgray};
            font-weight: ${props => props.theme.fontW.medium};
            ${CommonLimitStyle};
            -webkit-line-clamp: 1;
            line-height: 1.4rem;
          }
        } /*club-notice--board--item--btn */
      } /*club-notice--board--item */
    } /* club-notice--board */
  } /*club-notice */
`
